import React, { memo, useEffect, useMemo, useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';

import './CommonLoader.scss';

const CommonLoader = ({ isLoading, width = 50, strokeWidth = '5', disableScrolling, scrollableRef }) => {
  const [fixedTop, setFixedTop] = useState(0);

  useEffect(() => {
    if (!disableScrolling || !scrollableRef) {
      return;
    }
    const scrollableContainer = scrollableRef?.current;

    const scrollTop = scrollableContainer.scrollTop;
    setFixedTop(scrollTop ?? 0);

    const handlePreventParentScroll = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    if (isLoading) {
      scrollableContainer.addEventListener('wheel', handlePreventParentScroll, {
        passive: false,
      });
      scrollableContainer.addEventListener('touchmove', handlePreventParentScroll, {
        passive: false,
      });
    } else {
      scrollableContainer.removeEventListener('wheel', handlePreventParentScroll, {
        passive: false,
      });
      scrollableContainer.removeEventListener('touchmove', handlePreventParentScroll, {
        passive: false,
      });
    }

    return () => {
      scrollableContainer.removeEventListener('wheel', handlePreventParentScroll, {
        passive: false,
      });
      scrollableContainer.removeEventListener('touchmove', handlePreventParentScroll, {
        passive: false,
      });
    };
  }, [isLoading, disableScrolling]);

  const fixedStyles = useMemo(
    () => ({
      top: `${fixedTop}px`,
    }),
    [fixedTop],
  );

  if (!isLoading) {
    return null;
  }

  return (
    <div className='common-loader_overlay' style={fixedStyles}>
      <RotatingLines
        strokeColor='#fdbf47'
        strokeWidth={strokeWidth}
        animationDuration='0.75'
        width={width}
        visible={true}
      />
    </div>
  );
};

export default memo(CommonLoader);
